<template>
  <div class="login-guide-page">
  </div>
</template>

<script>
export default {
  name: "LoginGuidePage",
  data() {
    return {};
  },
  async mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.login-guide-page {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background-image: url("@/assets/style/startup.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.login-guide-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  img {
    width: 100%;
    height: 50%;
  }
}
.login-guide-text {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-45%, -50%);
  img {
    width: 254px;
    height: 141px;
  }
}
.login-guide-foot {
  position: absolute;
  top: 85%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  img {
    width: 50px;
    height: 50px;
    margin-right: 10px;
  }
  span {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 32px;
    color: #ffffff;
  }
}
</style>
